<template>
  <el-dialog
    :title="title"
    :visible.sync="isShow"
    width="580px"
    ref="answerDialogs"
    :close-on-click-modal="false"
    @close="close"
    class="answerDialog"
    style="padding-left: 30px; margin-top: 15vh"
    round
  >
    <div class="answer-con-list" v-if="ask">
      <!-- <div class="answer-con-list-header">
        <span class="answer-con-list-ask-name">{{ ask.askUserName }}</span>
        <span class="answer-con-list-ask-time">{{
          dateFormat(new Date(ask.askTime), 'HH:mm:ss')
        }}</span>
      </div> -->
      <div class="answer-con-list-ask-content">
        <span class="answer-con-list-ask-img">
          <!-- <img src="../../assets/images/ask.png" width="18px" height="18px"/> -->
          {{ $t('askAnswer.问') }} </span
        ><span class="answer-sequence">{{ ask.sequence }}.</span>
        <span class="answer-con-list-ask-text" v-html="quteChatContent(ask.content)"></span>
      </div>
    </div>
    <div class="bottom-send-msg">
      <div class="bottom-content">
        <div
          class="chat-edit scrollbar"
          ref="chatMessageRef"
          contenteditable
          :placeholder="$t('askAnswer.请输入回答内容')"
          @keydown="controlMaxLength($event)"
          @input="changeText($event)"
          @paste="monitorPaste($event)"
        ></div>
        <div class="bottom-bar-handel">
          <div class="bottom-bar-img" @mouseover="showList" @mouseleave="hideList">
            <a class="hover-list"><img :src="require('@/svg/icon-emoji.svg')" /></a>
            <ul class="emoji-list" ref="emojiList">
              <li v-for="(item, sub) in emojiListArr" :key="sub" @click="emojiClick(item)">
                <img :codes="item.codes" :src="emojiUrl(item)" class="emojiItem" />
              </li>
            </ul>
          </div>
          <div>
            <span style="color: #727480; font-size: 13px">{{ sendChatNumber }}/500</span>
          </div>
        </div>
      </div>
      <div class="ask-answer-people" v-if="ask">
        该问题有<span class="ask-answer-count">{{ numAnswer }}</span
        >人正在回答
      </div>
      <div class="bottom-bar-btn">
        <el-button size="mini" @click="close" class="bottom-bar-btn-cancel">
          {{ $t('askAnswer.取消') }}
        </el-button>
        <el-button
          class="bottom-bar-btn-sure"
          size="mini"
          @click="releaseFun"
          :disabled="sendChatNumber == 0 || isSending"
          >{{ $t('askAnswer.确定') }}</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { dateFormat } from '@/utils/global';
import emojiList from '@/utils/emoji.json';
import { answerAsk, pubAnswer, subAnswering } from '@/api/liveRequest/askAnswer';
import Bus from '../doc/bus';
export default {
  name: 'answer',
  data() {
    return {
      dateFormat: dateFormat,
      sendChatNumber: 0, //字数
      numAnswer: 0, //回答人数
      isSending: false //是否正在发送，flase没有发送，true正在发送
    };
  },
  computed: {
    isShow: {
      get() {
        return this.show;
      },
      set(val) {}
    },
    emojiListArr() {
      return emojiList;
    },
    liveToken() {
      return this.$store.getters.liveToken;
    },
    quteChatContent() {
      return (chatInfo) => {
        return this.chatListHandle(chatInfo);
      };
    },
    confId() {
      return this.$store.getters.confId;
    }
  },
  props: {
    ask: {
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    num: {
      type: Number
    }
  },
  created() {
    Bus.$on('updateNumAnswer', (val) => {
      this.numAnswer = val;
    });
  },
  // watch: {
  //   ask: {
  //     immediate: true,
  //     handler() {
  //       console.log(this.num, "数量变化");
  //if (this.ask) {
  //this.getAnswerCount();
  //this.numAnswer = val;
  //}
  //     }
  //   }
  // },
  methods: {
    // async getAnswerCount() {
    //   let param = { qaId: this.ask.qaId };
    //   const { data } = await getAnswering(param);
    //   this.numAnswer = data;
    // },
    showList() {
      this.$refs.emojiList.style.display = 'block';
    },
    hideList() {
      this.$refs.emojiList.style.display = 'none';
    },
    monitorPaste(event) {
      event.preventDefault(); // 获取剪贴板数据
      let paste = (event.clipboardData || window.clipboardData).getData('text/plain');
      document.execCommand('insertText', false, paste);
    },
    /**
     * 处理表情包
     * @param {*} chatData
     */
    chatListHandle(chatData) {
      if (!chatData) return;
      // let reg = RegExp('\\[1F60[0-9]{2,2}\\]', 'g');
      let reg = RegExp('\\[1F60\\d{1,4}\\]', 'g');
      //console.log(reg.test(chatData), "regMatch");
      if (reg.test(chatData)) {
        emojiList.forEach((item) => {
          let rules = new RegExp(`\\[${item.codes}\\]`, 'g');
          let _imgNameUrl = require(`@/assets/emoji/${item.imgName}`);
          chatData = chatData.replace(
            rules,
            `<img codes='${item.codes}' src='${_imgNameUrl}' class='chatEditSpan' width='20px'/>`
          );
        });
      }
      return chatData;
    },
    emojiClick(item) {
      let _imgNameUrl = require(`@/assets/emoji/${item.imgName}`);
      const Img = `<img codes="${item.codes}" src="${_imgNameUrl}" class="chatEditSpan" width="20px"/>`;
      let obj = this.$refs.chatMessageRef;
      let range, node;
      if (!obj.hasfocus) {
        obj.focus();
      }
      if (window.getSelection && window.getSelection().getRangeAt) {
        range = window.getSelection().getRangeAt(0);
        range.collapse(false);
        node = range.createContextualFragment(Img);
        let c = node.lastChild;
        range.insertNode(node);
        if (c) {
          range.setEndAfter(c);
          range.setStartAfter(c);
        }
        let j = window.getSelection();
        j.removeAllRanges();
        j.addRange(range);
      } else if (document.selection && document.selection.createRange) {
        document.selection.createRange().pasteHTML(Img);
      }
      this.changeText(true);
    },
    changeText() {
      let _chatMessageRef = this.$refs.chatMessageRef;
      let mssageVal = _chatMessageRef.innerHTML
        .replace(/<img[^>]*>/gi, 'a')
        .replace(/&nbsp;/g, 'b');

      if (mssageVal.length > 500) {
        setTimeout(() => {
          _chatMessageRef.innerHTML = this.getStr(
            _chatMessageRef.innerHTML.replace(/&nbsp;/g, ' ')
          );
          this.sendChatNumber = 500;
          this.keepLastIndex(_chatMessageRef);
        }, 0);
        return;
      }
      this.sendChatNumber = mssageVal.length;
    },
    // 光标移至最后
    keepLastIndex(obj) {
      obj.focus();
      document.execCommand('selectAll', false, null);
      document.getSelection().collapseToEnd();
    },
    getStr(str) {
      const reg = /((<[\s]*img.*?src=?(.*?)?\s.*?>)|[\d\D]){0,500}/gi;
      return reg.exec(str)[0];
    },
    emojiUrl(item) {
      return require(`@/assets/emoji/${item.imgName}`);
    },
    async close() {
      this.$refs.chatMessageRef.innerHTML = '';
      this.$emit('close');
      if (this.ask) {
        await subAnswering(this.ask, this.liveToken);
      }
    },
    controlMaxLength(e) {
      const ev = e || window.event;
      // 如果是回车
      if (ev.keyCode == 13) {
        this.releaseFun();
        ev.preventDefault();
        return false;
      }
    },
    async releaseFun() {
      if (this.isSending) return;
      this.isSending = true;
      let chatMessageRef = this.$refs.chatMessageRef;
      let content = chatMessageRef.innerHTML
        .replace(/<img[^>]*>/gi, (matchVal) => {
          let codes = this.parseToDOM(matchVal)[0].getAttribute('codes');
          return `[${codes}]`;
        })
        .replace(/&nbsp;/g, '');
      let params = { qaId: this.ask.qaId, replyContent: content.trim() };
      console.log(params, 'params')
      if (content.trim() !== '') {
        if (this.ask === false) {
          const { code, msg } = await pubAnswer({ content: content }, this.liveToken);
          if (code !== 200) {
            this.$message.error(msg);
          }
        } else {
          await answerAsk(params, this.liveToken);
        }
        this.isSending = false;
        chatMessageRef.innerHTML = '';
        this.sendChatNumber = 0;
        this.$emit('close');
      } else {
        this.isSending = false;
      }
    },
    parseToDOM(str) {
      var div = document.createElement('div');
      if (typeof str == 'string') div.innerHTML = str;
      return div.childNodes;
    }
  }
};
</script>
<style scoped lang="scss">
.answer-con-list {
  padding: 10px;
  &-header {
    display: flex;
    padding: 8px 0px;
    align-items: center;
    color: #acb2bf;
    line-height: 1;
  }
  &-ask {
    &-name {
      margin-right: 16px;
    }
    &-img {
      margin-right: 6px;
      flex-shrink: 0;
      background: url('../../assets/images/ask.png') no-repeat 0 0;
      width: 18px;
      height: 18px;
      line-height: 18px;
      background-size: cover;
      color: #fff;
      font-size: 10px;
      font-weight: 800;
      display: flex;
      justify-content: center;
    }
    &-content {
      display: flex;
      line-height: 1.5;
    }
    &-text {
      text-align: left;
      color: #fff;
      word-break: break-all;
    }
  }
}
.answer-sequence {
  color: #fff;
  flex-shrink: 0;
}
.chat-edit {
  cursor: text;
  overflow-x: hidden;
  overflow-y: auto;
  word-break: normal;
  font-size: 12px;
  text-align: left;
  outline: none;
  padding: 9px 12px 0;
  color: $white-color;
  white-space: pre-wrap;
  height: 140px;
  img {
    width: 12px;
    height: 12px;
  }
}
.bottom-content {
  width: 500px;
  height: 186px;
  background: #272a47;
  border-radius: 4px;
  border: 1px solid #444767;
}

.chat-edit:empty::before {
  content: attr(placeholder);
  color: #acb2bf;
  font-size: 12px;
}
::v-deep .el-dialog__body {
  padding: 20px;
}
.bottom-send-msg {
  padding: 0 9px;
  .bottom-bar-handel {
    display: flex;
    justify-content: space-between;
    height: 36px;
    align-items: center;
    padding: 0px 12px;
    position: relative;
    line-height: 1;

    .bottom-bar-img {
      img {
        width: 20px;
        cursor: pointer;
      }

      .mr10 {
        margin-right: 10px;
      }

      .bottom-bar-emoji:hover ~ .emoji-list {
        display: inline-block;
      }
    }
  }
}
.bottom-bar-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 20px 0;
  line-height: 1;
  button {
    border: none;
    border-radius: 6px;
  }
  &-cancel {
    background: #37384d;
    color: #acb2bf;
  }
  &-sure {
    background-color: $bule-color;
    color: $white-color;
  }
}

.emoji-list {
  display: none;
  width: 240px;
  position: absolute;
  text-align: left;
  background-color: #2d3052;
  border-radius: 6px;
  left: 0;
  top: 30px;
  padding: 6px;

  li {
    display: inline-block;
    padding: 4px;
    border-radius: 2px;

    > img {
      margin: 0px 3px;
      display: inline-block;
      width: 20px;
    }
  }
}

.emoji-list:hover {
  display: inline-block;
}
.ask-answer-people {
  display: flex;
  color: #acb2bf;
  align-items: center;
  padding-top: 8px;
  font-size: 12px;
  line-height: 1;
}
.ask-answer-count {
  color: #fff;
  font-size: 14px;
}
[data-theme='Orange'] .ask-answer-people,
[data-theme='Orange'] .ask-answer-count,
[data-theme='Orange'] .answer-sequence {
  color: #494a4d;
}
</style>
